import { useAppNotification } from "@hooks/useAppNotification";
import { AppNotificationModal } from "./AppNotificationModal";

export function FirstBrainstormNotification() {
  const { notification, dismiss, close, isDismissing } = useAppNotification("first_brainstorm");

  if (!notification) return null;

  return (
    <AppNotificationModal
      open
      onClose={close}
      onDismiss={dismiss}
      isDismissing={isDismissing}
      title="This is Houston. You're clear for launch."
      description="Here's what we're about to do together."
    >
      <div className="space-y-5">
        {/* The journey — primary content */}
        <div className="flex gap-4 text-sm text-[#2e3238]">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              1
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">Learn about your business</span>
            <p className="text-[#74767a] text-xs mt-0.5">Tell me what you do and who you serve.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              2
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">Build your website</span>
            <p className="text-[#74767a] text-xs mt-0.5">I'll write the copy, pick the design, and wire it all up.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              3
            </span>
          </div>
          <div>
            <span className="font-medium text-[#0f1113]">Launch your first ad campaign</span>
            <p className="text-[#74767a] text-xs mt-0.5">Google Ads, fully configured and ready to drive traffic.</p>
          </div>
        </div>

        {/* Chat power callout — secondary but visually distinct */}
        <div className="bg-[#f7f6f4] rounded-lg px-4 py-3">
          <p className="text-sm text-[#2e3238]">
            <span className="font-medium">The chat does everything.</span>{" "}
            Ask me to change your site, tweak your ads, or try a new angle — anytime.
          </p>
        </div>

        {/* After — tertiary, single line */}
        <p className="text-xs text-[#96989b]">
          When we're done, you can track performance, change your messaging, and manage your entire online presence from Launch10.
        </p>
      </div>
    </AppNotificationModal>
  );
}
